import { useState, useEffect } from "react";
import { useLang } from "@/components/LanguageContext";

const t = {
  es: {
    offer: "¡Oferta de Temporada!",
    discount: "20% de descuento en tu primera limpieza profunda.",
    spots: (n) => `Solo quedan ${n} plazas disponibles`,
  },
  en: {
    offer: "Seasonal Offer!",
    discount: "20% off your first deep cleaning.",
    spots: (n) => `Only ${n} spots left`,
  },
};

export default function UrgencyBanner() {
  const { lang } = useLang();
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [spotsLeft] = useState(7);

  useEffect(() => {
    const deadline = new Date();
    deadline.setHours(deadline.getHours() + 47);
    deadline.setMinutes(deadline.getMinutes() + 23);

    const timer = setInterval(() => {
      const now = new Date();
      const diff = deadline - now;
      if (diff <= 0) { clearInterval(timer); return; }
      setTimeLeft({
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");
  const tx = t[lang];

  return (
    <div className="bg-gray-950 border-b-2 border-green-500 text-white py-2 px-4 text-center text-sm font-semibold sticky top-0 z-50 shadow-md">
      <span className="inline-flex flex-wrap items-center justify-center gap-2">
        🌿 <span className="font-bold text-green-400">{tx.offer}</span>
        <span className="text-gray-200">{tx.discount}</span>
        <span className="bg-green-500 text-white rounded px-2 py-0.5 font-bold text-xs tracking-wider">
          ⏱ {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
        </span>
        <span className="text-green-300 font-bold">{tx.spots(spotsLeft)}</span>
      </span>
    </div>
  );
}